import {
  Box,
  Typography,
  Container,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useParams } from "react-router-dom";
import "../../Dashboard/components/recentActivities";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import arrow from "@/assets/arrow.png";
// import "./wheel.css";
import storage from "@/utils/storage";
import axios from "axios";
import { useEffect, useState } from "react";
import { shortenString } from "@/utils/utils";
import {
  CopyButton,
  Group,
  Text,
  Tooltip,
  Button,
  Popover,
} from "@mantine/core";
import {
  yellow,
  blue,
  red,
  orange,
  green,
  pink,
  purple,
} from "@mui/material/colors";
interface WinningListData {
  id: string;
  randomBall: number;
  winnerTicketNumber: string[];
  jackpotWinnerDetail: {
    winnerName: string;
    walletAddress: string;
    round: number;
    prize: string;
  };
  winningStatus: number;
  jackpotChosenNumber: string;
}
  const colors = [
    { light: yellow[700], dark: yellow[900] },
    { light: blue[700], dark: blue[900] },
    { light: red[700], dark: red[900] },
    { light: pink[900], dark: pink[800] },
    { light: orange[700], dark: orange[900] },
    { light: green[700], dark: green[900] },
    { light: purple[700], dark: purple[900] },
  ];
const useStyles = makeStyles(
  (theme: { breakpoints: { down: (arg0: string) => any } }) => ({
    root: {
      display: "flex",
      alignItems: "center",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      backgroundColor: "#FFFFFF1A",
      borderRadius: "15px",
    },
    ticketPrize: {
      background: "rgba(5, 5, 24, 0.8)",
      borderRadius: "10px",
      padding: "30px",
    },
    ticketContainer: {
      width: "134px",
      height: "60px",
      background: "#FFFF",
      borderRadius: "10px",
      position: "relative",
    },
    detailContainer: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "14px",
      padding: "12.86px",
    },
    detailLabel: {
      height: "11px",
      fontFamily: "Ubuntu",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "10px",
      lineHeight: "11px",
      color: "rgba(27, 28, 45, 0.6)",
      margin: "0",
    },
    detailNumber: {
      height: "23px",
      fontFamily: "Ubuntu",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "20.3636px",
      lineHeight: "23px",
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      color: "#27272F",
      margin: "0",
    },
    detailTime: {
      width: "82px",
      height: "16px",
      fontFamily: "Ubuntu",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "16px",
      color: "#1B1C2D",
      margin: "0",
    },
    media: {
      width: "40% !important",
      marginRight: "1rem",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        marginRight: "1rem",
      },
    },
    jackpotContainer: {
      display: "flex",
      justifyContent: "space-around",
      width: "100%",
      height: "38px",
      background: "rgba(60, 55, 255, 0.15)",
      marginBottom: "14px",
    },
    jackpotText: {
      width: "99px",
      height: "23px",
      fontFamily: "Ubuntu",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "20.3636px",
      lineHeight: "23px",
      letterSpacing: "0.2em",
      textTransform: "uppercase",
      color: "#27272F",
      margin: "auto",
    },
    arrowImage: {
      position: "absolute",
      width: "30px",
      height: "30px",
      left: "50%",
      transform: "translateX(-50%)",
    },
    polyup: {
      top: "-15px",
    },
    polydown: {
      bottom: "-15px",
      transform: "rotate(180deg)",
    },
    div1: {
      width: "100%",
      maxWidth: "100%", 
      minWidth: "280px",
      height: "180px",
      background: "#FFFFFF",
      borderRadius: "15px",
      cursor: "pointer",
      margin: "0 auto",
      transition: "all 0.3s ease",
      position: "relative",
      overflow: "hidden",
      "&:hover": {
        transform: "translateY(-5px)",
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
      },
      [theme.breakpoints.down("md")]: {
        maxWidth: "100%",
        minWidth: "260px",
        height: "170px",
      },
      [theme.breakpoints.down("sm")]: {
        height: "160px",
      },
    },
    gridContainer: {
      padding: "20px",
      background: "rgba(5, 5, 24, 0.8)",
      borderRadius: "20px",
      minHeight: "600px",
    },
    headerSection: {
      marginBottom: "24px",
      textAlign: "center",
    },
    winnerStats: {
      color: "rgba(255, 255, 255, 0.7)",
      marginBottom: "24px",
    },
  })
);

function WinningHistoryWheel() {
  const classes = useStyles();
  const { id } = useParams();
  const navigate = useNavigate();
  const [winningList, setWinningList] = useState({
    data: [
      {
        ticketNumber: 1234,
        playerName: "",
        prizeAmount: 500,
        price: "",
        lotteryWinningPrize: "",
        walletAddress: "",
        lotteryRank: "",
        firstName: "",
        userId: "",
        createdAt: "",
      },
    ],
  });

  const [jackpotData, setJackpotData] = useState<WinningListData | null>(null);
  console.log("jackpotData:", jackpotData);
  const [jackpotWinningData, setJackpotWinningData] = useState<any | null>(null);
  const [openedPopover, setOpenedPopover] = useState<string | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(3); // Number of tickets visible at once

  // Responsive items per slide
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setItemsToShow(1); // Mobile: 1 item
      } else if (width < 1024) {
        setItemsToShow(2); // Tablet: 2 items
      } else if (width < 1440) {
        setItemsToShow(3); // Desktop: 3 items
      } else if (width < 1920) {
        setItemsToShow(4); // Large Desktop: 4 items
      } else {
        setItemsToShow(5); // Extra Large: 5 items
      }
    };

    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Filter tickets into lottery and jackpot
  const lotteryTickets = winningList.data.filter((ticket: any) => ticket.lotteryRank !== 'jackpot');
  const jackpotTickets = winningList.data.filter((ticket: any) => ticket.lotteryRank === 'jackpot');
  
  // Create combined tickets array with jackpot ticket first (if it exists)
  const allTicketsForSlider: any[] = [];
  
  // Add jackpot ticket first if jackpot data exists and has valid content
  if (jackpotData && jackpotData.id && Object.keys(jackpotData).length > 0) {
    const jackpotTicket = {
      ticketNumber: jackpotData?.winnerTicketNumber?.[0] || "N/A",
      spinNumber: jackpotData?.jackpotWinnerDetail?.round ? jackpotData.jackpotWinnerDetail.round - 1 : 0,
      firstName: jackpotData?.jackpotWinnerDetail?.winnerName?.split(" ")[0] || "Winner",
      lotteryWinningPrize: Number(jackpotData?.jackpotWinnerDetail?.prize || 0).toLocaleString(),
      walletAddress: jackpotData?.jackpotWinnerDetail?.walletAddress || "",
      createdAt: new Date().toISOString().split('T')[0],
      isJackpot: true,
      userId: "jackpot-winner"
    };
    allTicketsForSlider.push(jackpotTicket);
  }
  
  // Add regular lottery tickets
  allTicketsForSlider.push(...lotteryTickets.map(ticket => ({ ...ticket, isJackpot: false })));
  
  // Get current visible tickets (including jackpot if present)
  const visibleTickets = allTicketsForSlider.slice(currentIndex, currentIndex + itemsToShow);
  
  // Navigation handlers
  const handlePrevious = () => {
    setCurrentIndex(prev => Math.max(0, prev - 1));
  };
  
  const handleNext = () => {
    setCurrentIndex(prev => Math.min(allTicketsForSlider.length - itemsToShow, prev + 1));
  };
  
  const canGoNext = currentIndex < allTicketsForSlider.length - itemsToShow;
  const canGoPrev = currentIndex > 0;

  useEffect(() => {
    getWinner();
    getJackpotWinningData();
    // postWinner();
  }, []);

  const getJackpotWinningData = async () => {
    let token = storage.getToken();

    try {
      const res = await axios.get(
        `${process.env.API_URL_PREFIX}/api/v1/user/playjackpot`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
          params: {
            lotteryId: id,
          },
        }
      );

      setJackpotWinningData(res.data);
      console.log("Jackpot API Response:", res.data);
      
      // Check if response has meaningful data (not empty object or null/undefined)
      if (res.data && Object.keys(res.data).length > 0 && res.data._id) {
        // Transform the API data to match WinningListData interface only if we have valid data
        const transformedData: WinningListData = {
          id: res.data.id || "1",
          randomBall: res.data.randomBall || 1,
          winnerTicketNumber: res.data.winnerTicketNumber || [],
          jackpotWinnerDetail: {
            winnerName: res.data.jackpotWinnerDetail?.winnerName || "No Winner",
            walletAddress: res.data.jackpotWinnerDetail?.walletAddress || "",
            round: res.data.jackpotWinnerDetail?.round || 1,
            prize: res.data.jackpotWinnerDetail?.prize || "0"
          },
          winningStatus: res.data.winningStatus || 0,
          jackpotChosenNumber: res.data.jackpotChosenNumber || "000000"
        };
        setJackpotData(transformedData);
      } else {
        // If response is empty or doesn't have valid data, don't set jackpot data
        console.log("No jackpot data available - response is empty or invalid");
        setJackpotData(null);
      }
    } catch (err: unknown) {
      if (axios.isAxiosError(err)) {
        console.log(
          "Error fetching jackpot data:",
          err.response ? err.response.data : err.message
        );
      } else {
        console.log("Unexpected error:", err);
      }
    }
  };

  // const postWinner = async () => {
  //   let token = storage.getToken();
  //   await axios
  //     .post(
  //       `${process.env.API_URL_PREFIX}/api/v1/user/lastTwoTicketNumPrize/` + id,
  //       {},
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Access-Control-Allow-Origin": "*",
  //         },
  //       }
  //     )
  //     .then((res) => {})

  //     .catch((err) => {});
  // };
  const getWinner = async () => {
    // postWinner();
    let token = storage.getToken();
    await axios
      .get(
        `${process.env.API_URL_PREFIX}/api/v1/user/lotteryWinnerList/` + id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        res?.data?.data.map((r) => {
          r.createdAt = r.createdAt.split("T")[0];
        });
        setWinningList(res?.data);
      })

      .catch((err) => {
        console.log(err);
      });
  };

  // Render individual ticket card
  const renderTicketCard = (winner: any, keyPrefix: string, isJackpot: boolean = false) => {
    // Special jackpot rendering logic
    if (isJackpot && jackpotData) {
      return (
        <Box
          className="div1"
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: { xs: "100%", sm: "320px" },
            minHeight: "180px",
            background: jackpotData?.jackpotWinnerDetail?.winnerName !== "NA" ?
              "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)" :
              (jackpotData?.randomBall !== undefined
                ? colors[(jackpotData.randomBall - 1) % colors.length]?.light ||
                "#ffffff"
                : "#ffffff"),
            borderRadius: "15px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-5px)",
              boxShadow: "0 10px 30px rgba(255, 215, 0, 0.4)",
            },
            overflow: "hidden",
            border: "2px solid #FFD700",
            margin: { xs: "0 auto", sm: "0" },
          }}
        >
          
          {jackpotData?.jackpotWinnerDetail?.winnerName !== "NA" ? (
            <>
              {/* Jackpot Winner Display */}
              <Box className="detail detail1" sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                padding: '14px 20px 8px 20px' 
              }}>
                <Box>
                  <Typography 
                    variant="body1" 
                    component="label"
                    sx={{
                      fontSize: '10px',
                      fontWeight: 500,
                      color: 'rgba(0, 0, 0, 0.7)',
                      display: 'block',
                      marginBottom: '4px'
                    }}
                  >
                    Ticket no
                  </Typography>
                  <Typography 
                    variant="body2" 
                    className="number"
                    sx={{
                      fontSize: '16px',
                      fontWeight: 700,
                      color: '#000',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }}
                  >
                    {jackpotData?.winnerTicketNumber?.[0] || "N/A"}
                  </Typography>
                </Box>
                <Box>
                  <Typography 
                    variant="body1" 
                    component="label"
                    sx={{
                      fontSize: '10px',
                      fontWeight: 500,
                      color: 'rgba(0, 0, 0, 0.7)',
                      display: 'block',
                      marginBottom: '4px'
                    }}
                  >
                    Jackpot Round
                  </Typography>
                  <Typography 
                    variant="body2" 
                    className="number"
                    sx={{
                      fontSize: '16px',
                      fontWeight: 700,
                      color: '#000',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }}
                  >
                    {jackpotData?.jackpotWinnerDetail?.round || 1}
                  </Typography>
                </Box>
              </Box>
              
              <Box className="jackpot" sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: 'rgba(0, 0, 0, 0.1)',
                padding: '10px 20px',
                margin: '8px 0'
              }}>
                <Typography 
                  variant="body1" 
                  component="p"
                  sx={{
                    fontSize: '16px',
                    fontWeight: 700,
                    color: '#000',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    margin: 0
                  }}
                >
                  JACKPOT PRIZE:
                </Typography>
                <Typography 
                  variant="body1" 
                  component="p"
                  sx={{ 
                    fontSize: '20px',
                    fontWeight: 'bold', 
                    color: '#000',
                    margin: 0,
                    textShadow: '0 0 10px rgba(0,0,0,0.3)'
                  }}
                >
                  ${Number(jackpotData?.jackpotWinnerDetail?.prize || 0).toLocaleString()}
                </Typography>
              </Box>
              
              <Box className="detail detail2" sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                padding: '0 20px 14px 20px' 
              }}>
                <Box>
                  <Typography 
                    variant="body1" 
                    component="label"
                    sx={{
                      fontSize: '10px',
                      fontWeight: 500,
                      color: 'rgba(0, 0, 0, 0.7)',
                      display: 'block',
                      marginBottom: '4px'
                    }}
                  >
                    Winner Name
                  </Typography>
                  <Typography 
                    variant="body2" 
                    className="number"
                    sx={{
                      fontSize: '16px',
                      fontWeight: 700,
                      color: '#000',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em'
                    }}
                  >
                    {jackpotData?.jackpotWinnerDetail?.winnerName?.split(" ")[0] || "Winner"}
                  </Typography>
                </Box>
                <Box>
                  <Typography 
                    variant="body1" 
                    component="label"
                    sx={{
                      fontSize: '10px',
                      fontWeight: 500,
                      color: 'rgba(0, 0, 0, 0.7)',
                      display: 'block',
                      marginBottom: '4px'
                    }}
                  >
                    Blockchain Address
                  </Typography>
                  <Typography 
                    variant="body2" 
                    className="time"
                    sx={{
                      fontSize: '12px',
                      fontWeight: 500,
                      color: 'rgba(0, 0, 0, 0.8)'
                    }}
                  >
                    {jackpotData?.jackpotWinnerDetail?.walletAddress ? 
                      `${jackpotData.jackpotWinnerDetail.walletAddress.slice(0, 6)}...${jackpotData.jackpotWinnerDetail.walletAddress.slice(-4)}` : 
                      "N/A"
                    }
                  </Typography>
                </Box>
              </Box>
              
              {/* Jackpot Crown Effect */}
              <Box
                sx={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "rgba(255, 255, 255, 0.2)",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                  animation: "pulse 2s infinite"
                }}
              >
                👑
              </Box>

              {/* Random Ball Display */}
              <Box
                sx={{
                  position: "absolute",
                  top: "10px",
                  left: "10px",
                  background: "rgba(0, 0, 0, 0.2)",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#000"
                }}
              >
                {jackpotData?.randomBall || "🎲"}
              </Box>
            </>
          ) : (
            <>
              {/* No Jackpot Winner Display */}
              <Box sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                padding: "20px"
              }}>
                <Typography 
                  variant="body1" 
                  component="p"
                  sx={{ 
                    color: "#000", 
                    fontSize: "24px", 
                    fontWeight: "300",
                    marginBottom: "10px",
                    textAlign: "center"
                  }}
                >
                  Ticket no.
                </Typography>
                <Typography
                  variant="body2"
                  className="number"
                  sx={{
                    color: "#000",
                    fontSize: "32px",
                    fontWeight: "bold",
                    marginBottom: "20px",
                    textAlign: "center"
                  }}
                >
                  {jackpotData?.winnerTicketNumber?.[0] || "N/A"}
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  sx={{ 
                    color: "#000", 
                    fontSize: "22px", 
                    fontWeight: "500",
                    textAlign: "center",
                    marginBottom: "10%"
                  }}
                >
                  No Jackpot Winner
                </Typography>
              </Box>

              {/* Random Ball Display */}
              <Box
                sx={{
                  position: "absolute",
                  top: "10px",
                  left: "10px",
                  background: "rgba(0, 0, 0, 0.2)",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#000"
                }}
              >
                {jackpotData?.randomBall || "🎲"}
              </Box>
            </>
          )}
          
          {/* Decorative Arrows */}
          <img 
            src={arrow} 
            alt="Up Arrow" 
            className="polyup" 
            style={{ 
              filter: 'brightness(0.3)',
              opacity: 0.7
            }} 
          />
          <img 
            src={arrow} 
            alt="Down Arrow" 
            className="polydown"
            style={{ 
              filter: 'brightness(0.3)',
              opacity: 0.7
            }} 
          />
        </Box>
      );
    }

    // Regular lottery ticket rendering
    return (
      <Box
        className="div1"
        onClick={() => {
          if (winner.userId === storage.getUserId()) {
            navigate("/app/wallet/MyLottery");
          }
        }}
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: { xs: "100%", sm: "320px" },
          height: "180px",
          minHeight: "180px",
          background: "#FFFFFF",
          borderRadius: "15px",
          cursor: "pointer",
          transition: "all 0.3s ease",
          "&:hover": {
            transform: "translateY(-5px)",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          },
          overflow: "hidden",
          margin: { xs: "0 auto", sm: "0" },
        }}
      >
        <Box className="detail detail1" sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          padding: '14px 20px 8px 20px' 
        }}>
          <Box>
            <Typography 
              variant="body1" 
              component="label"
              sx={{
                fontSize: '10px',
                fontWeight: 500,
                color: 'rgba(27, 28, 45, 0.6)',
                display: 'block',
                marginBottom: '4px'
              }}
            >
              Ticket no
            </Typography>
            <Typography 
              variant="body2" 
              className="number"
              sx={{
                fontSize: '16px',
                fontWeight: 700,
                color: '#27272F',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}
            >
              {winner.ticketNumber}
            </Typography>
          </Box>
          <Box>
            <Typography 
              variant="body1" 
              component="label"
              sx={{
                fontSize: '10px',
                fontWeight: 500,
                color: 'rgba(27, 28, 45, 0.6)',
                display: 'block',
                marginBottom: '4px'
              }}
            >
              Spin no.
            </Typography>
            <Typography 
              variant="body2" 
              className="number"
              sx={{
                fontSize: '16px',
                fontWeight: 700,
                color: '#27272F',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}
            >
              {winner?.spinNumber + 1}
            </Typography>
          </Box>
          <Box>
            <Typography 
              variant="body1" 
              component="label"
              sx={{
                fontSize: '10px',
                fontWeight: 500,
                color: 'rgba(27, 28, 45, 0.6)',
                display: 'block',
                marginBottom: '4px'
              }}
            >
              Date
            </Typography>
            <Typography 
              variant="body2" 
              className="time"
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                color: '#1B1C2D'
              }}
            >
              {winner?.createdAt}
            </Typography>
          </Box>
        </Box>
        
        <Box className="jackpot" sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: 'rgba(60, 55, 255, 0.15)',
          padding: '10px 20px',
          margin: '8px 0'
        }}>
          <Typography 
            variant="body1" 
            component="p"
            sx={{
              fontSize: '16px',
              fontWeight: 700,
              color: '#27272F',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              margin: 0
            }}
          >
            Prize:
          </Typography>
          <Typography 
            variant="body1" 
            component="p"
            sx={{ 
              fontSize: '18px',
              fontWeight: 'bold', 
              color: '#4CAF50',
              margin: 0
            }}
          >
            ${winner?.lotteryWinningPrize}
          </Typography>
        </Box>
        
        <Box className="detail detail2" sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          padding: '0 20px 14px 20px' 
        }}>
          <Box>
            <Typography 
              variant="body1" 
              component="label"
              sx={{
                fontSize: '10px',
                fontWeight: 500,
                color: 'rgba(27, 28, 45, 0.6)',
                display: 'block',
                marginBottom: '4px'
              }}
            >
              Player Nick Name
            </Typography>
            <Typography 
              variant="body2" 
              className="number"
              sx={{
                fontSize: '16px',
                fontWeight: 700,
                color: '#27272F',
                textTransform: 'uppercase',
                letterSpacing: '0.05em'
              }}
            >
              {winner?.firstName}
            </Typography>
          </Box>
          <Box>
            <Popover
              opened={openedPopover === `${keyPrefix}-${winner.ticketNumber}`}
              position="top"
              withArrow
              withinPortal
              width="auto"
              styles={{
                dropdown: { padding: 8, cursor: "default" },
              }}
              onClose={() => setOpenedPopover(null)}
            >
              <Popover.Target>
                <Box
                  onMouseEnter={() =>
                    setOpenedPopover(`${keyPrefix}-${winner.ticketNumber}`)
                  }
                  onMouseLeave={() => setOpenedPopover(null)}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Typography 
                    variant="body1" 
                    component="label"
                    sx={{
                      fontSize: '10px',
                      fontWeight: 500,
                      color: 'rgba(27, 28, 45, 0.6)',
                      display: 'block',
                      marginBottom: '4px'
                    }}
                  >
                    Blockchain Address
                  </Typography>
                  <Typography 
                    variant="body2" 
                    className="time"
                    sx={{
                      fontSize: '12px',
                      fontWeight: 500,
                      color: '#1B1C2D'
                    }}
                  >
                    {shortenString(winner?.walletAddress)}
                  </Typography>
                </Box>
              </Popover.Target>
              {/* <Popover.Dropdown
                onClick={(e) => e.stopPropagation()}
              >
                <Group spacing="xs">
                  <Text
                    size="sm"
                    style={{
                      userSelect: "text",
                      wordBreak: "break-all",
                    }}
                  >
                    {winner?.walletAddress}
                  </Text>
                  <CopyButton value={winner?.walletAddress}>
                    {({ copied, copy }) => (
                      <Button
                        variant="light"
                        color={copied ? "teal" : "blue"}
                        size="xs"
                        onClick={(e) => {
                          e.stopPropagation();
                          copy();
                        }}
                      >
                        {copied ? "Copied" : "Copy"}
                      </Button>
                    )}
                  </CopyButton>
                </Group>
              </Popover.Dropdown> */}
            </Popover>
          </Box>
        </Box>
        
        {/* Decorative Arrows */}
        <img 
          src={arrow} 
          alt="Up Arrow" 
          className="polyup" 
        />
        <img 
          src={arrow} 
          alt="Down Arrow" 
          className="polydown"
        />
      </Box>
    );
  };

  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          padding: "20px",
          background: "rgba(5, 5, 24, 0.8)",
          borderRadius: "20px",
          minHeight: "300px",
        }}
      >
        {winningList.data.length > 0 && winningList.data[0].playerName !== "" ? (
          <>
            {/* Header */}
            <Box sx={{ mb: 3, textAlign: "center" }}>
              <Typography
                variant="h4"
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  mb: 1,
                }}
              >
                🏆 Winning History
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  color: "rgba(255, 255, 255, 0.7)",
                  mb: 3,
                }}
              >
                Total Winners: {allTicketsForSlider.length} {(jackpotData && jackpotData.id && Object.keys(jackpotData).length > 0) ? `(${lotteryTickets.length} Lottery + 1 Jackpot)` : `(${lotteryTickets.length} Lottery)`}
              </Typography> */}
              <Typography
                variant="body1"
                sx={{
                  color: "rgba(255, 255, 255, 0.7)",
                  mb: 3,
                }}
              >
                Congratulations, please claim your price.
              </Typography>
            </Box>

            {/* Horizontal Strip Layout - Full Width Slider */}
            <Box sx={{ 
              position: "relative",
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "15px",
              padding: { xs: "15px", sm: "20px" },
              overflow: "hidden"
            }}>
              <Box sx={{ 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center", 
                mb: 2,
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: 1, sm: 0 }
              }}>
                <Typography variant="h6" sx={{ 
                  color: "white", 
                  fontWeight: "bold",
                  fontSize: { xs: "1rem", sm: "1.25rem" }
                }}>
                  🎟️ All Winners 
                </Typography>
                
                {/* Navigation Buttons */}
                <Box sx={{ display: "flex", gap: 1 }}>
                  <IconButton
                    onClick={handlePrevious}
                    disabled={!canGoPrev}
                    sx={{
                      color: "white",
                      backgroundColor: canGoPrev ? "rgba(255, 255, 255, 0.1)" : "rgba(255, 255, 255, 0.05)",
                      "&:hover": {
                        backgroundColor: canGoPrev ? "rgba(255, 255, 255, 0.2)" : "rgba(255, 255, 255, 0.05)",
                      },
                      "&:disabled": {
                        color: "rgba(255, 255, 255, 0.3)",
                      },
                      width: { xs: "35px", sm: "40px" },
                      height: { xs: "35px", sm: "40px" }
                    }}
                  >
                    <ArrowBackIosIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    onClick={handleNext}
                    disabled={!canGoNext}
                    sx={{
                      color: "white",
                      backgroundColor: canGoNext ? "rgba(255, 255, 255, 0.1)" : "rgba(255, 255, 255, 0.05)",
                      "&:hover": {
                        backgroundColor: canGoNext ? "rgba(255, 255, 255, 0.2)" : "rgba(255, 255, 255, 0.05)",
                      },
                      "&:disabled": {
                        color: "rgba(255, 255, 255, 0.3)",
                      },
                      width: { xs: "35px", sm: "40px" },
                      height: { xs: "35px", sm: "40px" }
                    }}
                  >
                    <ArrowForwardIosIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>

              {/* Scrollable Tickets Container */}
              <Box sx={{ 
                display: "flex", 
                justifyContent: "center",
                alignItems: "center",
                gap: { xs: "12px", sm: "16px", md: "20px" }, 
                height: { xs: "200px", sm: "220px", md: "240px", lg: "260px" },
                transition: "transform 0.3s ease",
                overflow: "hidden"
              }}>
                {visibleTickets.length > 0 ? visibleTickets.map((winner: any, index: number) => {
                  let flexBasis = "0 0 calc(33.33% - 10px)";
                  let minWidth = "260px";
                  let maxWidth = "320px";
                  
                  if (itemsToShow === 1) {
                    flexBasis = "0 0 calc(100% - 12px)";
                    minWidth = "calc(100% - 12px)";
                    maxWidth = "calc(100% - 12px)";
                  } else if (itemsToShow === 2) {
                    flexBasis = "0 0 calc(50% - 8px)";
                    minWidth = "260px";
                    maxWidth = "320px";
                  } else if (itemsToShow === 4) {
                    flexBasis = "0 0 calc(25% - 15px)";
                    minWidth = "220px";
                    maxWidth = "280px";
                  } else if (itemsToShow === 5) {
                    flexBasis = "0 0 calc(20% - 16px)";
                    minWidth = "200px";
                    maxWidth = "260px";
                  }
                  
                  return (
                  <Box
                    key={`${winner.isJackpot ? 'jackpot' : 'lottery'}-${winner.ticketNumber}-${index}`}
                    sx={{
                      flex: flexBasis,
                      minWidth: minWidth,
                      maxWidth: maxWidth,
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      padding: itemsToShow === 1 ? "0 6px" : "0",
                    }}
                  >
                    {renderTicketCard(winner, `${winner.isJackpot ? 'jackpot' : 'lottery'}-${index}`, winner.isJackpot)}
                  </Box>
                  );
                }) : (
                  <Box sx={{ 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center",
                    width: "100%",
                    color: "rgba(255, 255, 255, 0.5)"
                  }}>
                    <Typography>No winners yet</Typography>
                  </Box>
                )}
              </Box>
            </Box>

            {/* Pagination Info */}
            <Box sx={{ 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center",
              mt: 3,
              gap: { xs: 1, sm: 2 },
              flexDirection: { xs: "column", sm: "row" },
              textAlign: "center"
            }}>
              <Typography variant="body2" sx={{ 
                color: "rgba(255, 255, 255, 0.6)",
                fontSize: { xs: "0.75rem", sm: "0.875rem" }
              }}>
                Showing {visibleTickets.length} of {allTicketsForSlider.length} total winners
              </Typography>
              {allTicketsForSlider.length > itemsToShow && (
                <Typography variant="body2" sx={{ 
                  color: "rgba(255, 255, 255, 0.4)",
                  fontSize: { xs: "0.75rem", sm: "0.875rem" }
                }}>
                  • Page {Math.floor(currentIndex / itemsToShow) + 1} of {Math.ceil(allTicketsForSlider.length / itemsToShow)}
                </Typography>
              )}
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "200px",
              color: "rgba(255, 255, 255, 0.7)",
            }}
          >
            <Typography variant="h5" sx={{ mb: 2 }}>
              🎰 No Winners Yet
            </Typography>
            <Typography variant="body1">
              Be the first to win in this lottery!
            </Typography>
          </Box>
        )}
      </Box>
    </Container>
  );
}

export default WinningHistoryWheel;
